export default "__VITE_ASSET__CICbFCPo__"